import { useTranslation } from 'react-i18next';

import type { Platform } from '@/types/qriots';

interface RegionPickerModalProps {
  current?: Platform;
  onPick: (p: Platform) => void;
  onClose: () => void;
  hint?: string;
}

const REGIONS: Array<{ code: Platform; label: string }> = [
  { code: 'EUW1', label: 'Europe West' },
  { code: 'EUN1', label: 'Europe Nordic & East' },
  { code: 'NA1', label: 'North America' },
  { code: 'KR', label: 'Korea' },
  { code: 'BR1', label: 'Brazil' },
  { code: 'JP1', label: 'Japan' },
  { code: 'TR1', label: 'Turkey' },
  { code: 'RU', label: 'Russia' },
  { code: 'LA1', label: 'Latin America North' },
  { code: 'LA2', label: 'Latin America South' },
  { code: 'OC1', label: 'Oceania' },
];

export function RegionPickerModal({ current, onPick, onClose, hint }: RegionPickerModalProps) {
  const { t } = useTranslation('riot');
  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 sm:items-center">
      <div className="max-h-[80vh] w-full overflow-y-auto rounded-t-2xl bg-bg p-4 sm:max-w-md sm:rounded-2xl">
        <div className="mb-3 flex items-center justify-between">
          <h3 className="text-sm font-bold text-fg">{t('cta.switchRegion')}</h3>
          <button
            type="button"
            onClick={onClose}
            className="text-sm text-fg-muted active:opacity-80"
          >
            ✕
          </button>
        </div>
        {hint && <p className="mb-3 text-xs text-fg-muted">{hint}</p>}
        <ul className="flex flex-col gap-1">
          {REGIONS.map((r) => (
            <li key={r.code}>
              <button
                type="button"
                onClick={() => onPick(r.code)}
                className={`flex w-full items-center justify-between rounded-lg px-3 py-2 text-sm transition-opacity active:opacity-80 ${
                  r.code === current ? 'bg-brand/15 text-brand' : 'bg-bg-secondary text-fg'
                }`}
              >
                <span>{r.label}</span>
                <span className="text-xs text-fg-muted">{r.code}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
